export function resolveBoxesParameter({ parameter, currentFilters, previousFilters }) {
    if (!parameter) {
        return '';
    }

    const previousTense = previousFilters?.[parameter]?.tense;
    const currentTense = currentFilters?.[parameter]?.tense;

    // If tense changed for the active category, force a full refresh so
    // that category is not preserved from stale boxes.
    return previousTense !== currentTense ? '' : parameter;
}

export function mergeBoxesWithPreservedCategory({ responseData, parameter, currentBoxes }) {
    const preservedCategory = parameter && currentBoxes?.[parameter] ? currentBoxes[parameter] : null;

    if (preservedCategory) {
        return {
            ...responseData,
            [parameter]: preservedCategory,
        };
    }

    return responseData;
}

// eslint-disable-next-line complexity
export function getFilterTagLabels({ filters, boxes = {}, getBoxLabel, getFilterBoxTagLabel, getFilterLabel }) {
    if (!filters || typeof filters !== 'object') {
        return {};
    }

    const result = {};

    for (const category in filters) {
        const filter = filters[category];
        if (!filter) {
            continue;
        }

        // If caller provided a getFilterBoxTagLabel and boxes are available, prefer that.
        if (Array.isArray(filter.boxes) && filter.boxes.length > 0) {
            const availableBoxes = boxes?.[category];

            if (typeof getFilterBoxTagLabel === 'function') {
                result[category] = getFilterBoxTagLabel(filter, availableBoxes);
                continue;
            }

            if (typeof getBoxLabel === 'function') {
                result[category] = filter.boxes.map(boxId => getBoxLabel(boxId, category));
                continue;
            }

            continue;
        }

        // Non-box filters: use `getFilterLabel(category, filter)` when available.
        if (typeof getFilterLabel === 'function') {
            result[category] = getFilterLabel(category, filter);
            continue;
        }

        // Default fallback: store the filter object/value as-is
        result[category] = filter;
    }

    return result;
}
